/** A type guard used in place of callbacks that assert that a value is non-nullable.
 * @example
 * const array = [1, 2, undefined, 3, null] // (number | undefined | null)[]
 * const mistypedFilteredArray = array.filter(Boolean) // (number | undefined | null)[] ❌
 * const filteredArray = array.filter(isNonNullable) // number[] ✅
 */
export default function isNonNullable(value) {
    return value !== null && value !== undefined;
}
